var e = /* @__PURE__ */ ((a) => (a.QA = "qa", a.Staging = "staging", a.Live = "live", a))(e || {});
export {
  e as Env
};
